import { render } from "./Slider.vue?vue&type=template&id=59e9196b&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "@/assets/scss/_slider.scss?vue&type=style&index=0&id=59e9196b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e9196b"]])

export default __exports__